import { useMemo } from "react";
import { RenderObject } from "../../../../types/chat";

interface RenderComponentProps {
  renderObject: RenderObject;
}

/**
 * Component that renders different UI elements based on direct component reference or render function
 */
const RenderComponent: React.FC<RenderComponentProps> = ({ renderObject }) => {
  const renderContent = useMemo(() => {
    // If render function is provided, use it
    if (renderObject.render) {
      return renderObject.render();
    }

    // If component is directly provided, render it with props
    if (renderObject.component) {
      const Component = renderObject.component;
      return <Component {...renderObject.props} />;
    }

    // If neither component nor render function is provided, render data as fallback
    if (renderObject.data) {
      return <p>{JSON.stringify(renderObject.data)}</p>;
    }

    return null;
  }, [renderObject]);

  return renderContent;
};

export default RenderComponent;
